export const obtenerInicioDelDia = (fecha) => {
  fecha.setHours(0, 0, 0, 0);
  return fecha;
};

export const obtenerFinDelDia = (fecha) => {
  fecha.setHours(23, 59, 59, 999);
  return fecha;
};
